import { render } from "./ClinicBrandingPreview.vue?vue&type=template&id=86821940&scoped=true"
import script from "./ClinicBrandingPreview.vue?vue&type=script&lang=js"
export * from "./ClinicBrandingPreview.vue?vue&type=script&lang=js"

import "./ClinicBrandingPreview.vue?vue&type=style&index=0&id=86821940&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86821940"]])

export default __exports__